import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { environment } from '../../environments/environment';
import { O365AuthService } from '../services/o365-auth.service';
import { filter, map, take } from 'rxjs';
import { InteractionStatus } from '@azure/msal-browser';

export const authGuard: CanActivateFn = (route, state) => {
  const msalService = inject(MsalService);
  const authService = inject(O365AuthService);

  return authService.isInitialized$.pipe(
    filter(init => init),
    take(1),
    map(() => {
      const account = msalService.instance.getActiveAccount();
      if (!account) {
        console.log('AUTH GUARD loginRedirect');
        msalService.loginRedirect({
          scopes: ['api://' + environment.azureAd.apiAppId + '/' + environment.azureAd.apiScope],
          redirectStartPage: state.url
        });
        return false;
      } else {
        console.debug('AUTH GUARD valid account', account.username)
      }
      return true;
    })
  );
};


